import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { useUiStore } from '@/stores/uiStore'

export function AppLayout() {
	const sidebarOpen = useUiStore((s) => s.sidebarOpen)

	return (
		<div className="flex h-screen flex-col bg-surface">
			<Header />
			<div className="flex flex-1 overflow-hidden">
				{sidebarOpen && <Sidebar />}
				<main className="flex-1 overflow-y-auto p-3 md:p-6">
					<Outlet />
				</main>
			</div>
		</div>
	)
}
